module.exports = __webpack_public_path__ + "media/images/front/pc/dummy/banner_mn-df8cb193ec7ae889717646934f1fb69d.png";